export default "__VITE_ASSET__DUw0GSy$__"